// src/components/BoomWMSLayer.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const BoomWMSLayer = ({ view }) => {
  useEffect(() => {
    if (!view || !view.map) return;

    let boomLayer;

    loadModules(['esri/layers/WMSLayer']).then(([WMSLayer]) => {
      boomLayer = new WMSLayer({
        title: "BOOM Data",
        url: "https://portal.boom-h2-pipelines.com/geoserver/postgis/wms?",
        sublayers: [
          {
            title: "Cadastre",
            name: "parcela",
            queryable: true,
            popupEnabled: true,
            visible: false
          },       
          {
            title: "ENVIRONMENTAL - atlashabitats2005_extremadura",
            name: "ENV_atlashabitats2005_extremadura",
            queryable: true,
            popupEnabled: true,
            visible: false
          },      
          {
            title: "ENVIRONMENTAL - zonificacionzir_sierradesanpedroed50h30",
            name: "ENV_zonificacionzir_sierradesanpedroed50h30",
            queryable: true,
            popupEnabled: true,
            visible: false
          },                     
          {
            title: "ENVIRONMENTAL - zonificacionzir_llanosdecaceresed50h30",
            name: "ENV_zonificacionzir_llanosdecaceresed50h30",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - zonificacionzepa_embalse_de_valdecañased50h30",
            name: "ENV_zonificacionzepa_embalse_de_valdecañased50h30",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - zonificacion_prug",
            name: "ENV_zonificacion_prug",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - zonas_ramsar_extremadura_etrs89h30",
            name: "ENV_zonas_ramsar_extremadura_etrs89h30",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - zepa_extremadura_es_spa_202512",
            name: "ENV_zepa_extremadura_es_spa_202512",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - reservasdelabiosferadeextremadura",
            name: "ENV_reservasdelabiosferadeextremadura",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - renpex_etrs89h30_20210607",
            name: "ENV_renpex_etrs89h30_20210607",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - hb6310",
            name: "ENV_hb6310",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENVIRONMENTAL - habitats_92_43_cee_extremadura",
            name: "ENV_habitats_92_43_cee_extremadura",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENAGAS - Zona de Estudio",
            name: "zona_de_estudio",
            queryable: true,
            popupEnabled: true,
            visible: false
          },
          {
            title: "ENAGAS - Corredores de Paso",
            name: "corredores_de_paso",
            queryable: true,
            popupEnabled: true,
            visible: false
          },             
          {
            title: "ENAGAS - Posiciones",
            name: "posiciones",
            queryable: true,
            popupEnabled: true,
            visible: false
          },   
          {
            title: "Opportunities",
            name: "opportunities_pt",
            queryable: true,
            popupEnabled: true
          },
          {
            title: "Enagas Backbone Compression Station",
            name: "future_tie_ins_pt",
            queryable: true,
            popupEnabled: true
          },
          {
            title: "Cost Estimation",
            name: "redlines",
            queryable: true,
            popupEnabled: true
          }
        ]
      });

      view.map.add(boomLayer);
    });

    return () => {
      if (view?.map && boomLayer) {
        view.map.remove(boomLayer);
        boomLayer.destroy();
      }
    };
  }, [view]);

  return null;
};

export default BoomWMSLayer;
